import { AppConfig } from './AppConfig';

const baseUrl = 'https://demo.pharmagarde.be';
const basePlannerUrl = 'http://ec2-63-33-193-111.eu-west-1.compute.amazonaws.com:8080';

const config: AppConfig = {
  configName: 'Uphoc-Demo',
  applicationTitle: 'WebGardes',
  hubUrl: `${baseUrl}/pharmagardeHub`,
  apiUrl: `${baseUrl}/api/`,
  plannerApiUrl: `${basePlannerUrl}/planner/`,
  googleMapApiKey: 'AIzaSyAHKfZ1yH7pudlmQ4441Plv9Aiic1tunQc',
  dateFormat: 'DD/MM/YYYY',
  dateFormatWithDay: 'ddd DD/MM/YYYY',
  dateTimeFormat: 'DD/MM/YYYY HH:mm',};

export default config;
